import axios from 'axios'
import misc from '@/services/misc'
import endpoints from '@/api/endpoints'
import _ from 'lodash'

export default {
  // Basics
  async createEstimateLineItem (line) {
    return axios.post(endpoints.estimateLineItems, line).then((response) => {
      return response.data
    })
  },
  async getEstimateLineItems (id = null) {
    // the `id` refers to the connected Estimate
    if (id) {
      id = '?is_optional=false&estimate=' + id
    } else {
      id = '?is_optional=false'
    }
    return axios.get(endpoints.estimateLineItems + id).then((response) => {
      return response.data
    })
  },
  async updateEstimateLineItem (item) {
    return axios.patch(endpoints.estimateLineItems + item.id + '/', item).then((response) => {
      return response.data
    })
  },
  async updateEstimateLineItemOrder (lines) {
    return axios.post(endpoints.estimateLineItems + 'order/', lines).then((response) => {
      return response.data
    })
  },
  async createOptionalLineItem (line) {
    // Forces the line item to have `is_optional` to be true
    line.is_optional = true
    return axios.post(endpoints.estimateLineItems, line).then((response) => {
      return response.data
    })
  },
  async getOptionalLineItems (id = null) {
    // the `id` refers to the connected Estimate
    // This function ensures you only get optional line items back
    if (id) {
      id = '?is_optional=true&estimate=' + id
    } else {
      id = '?is_optional=true'
    }
    return axios.get(endpoints.estimateLineItems + id).then((response) => {
      return response.data
    })
  },
  async updateOptionalLineItem (item) {
    return axios.patch(endpoints.optionalLineItems + item.id + '/', item).then((response) => {
      return response.data
    })
  },
  async sortItemDown (item, allItems) {
    /*
    Moves a singe line item DOWN in the order of line items.
    Takes care of PATCHing all the related linked list pointers for the related
    estimate line items
    */
    let itemAfter = _.find(allItems, function (i) { return i.comes_after === item.id })
    let doubleAfter = _.find(allItems, function (i) { return i.comes_after === itemAfter.id })
    let newAllItems = null
    itemAfter.comes_after = item.comes_after
    item.comes_after = itemAfter.id
    if (doubleAfter) {
      doubleAfter.comes_after = item.id
    }

    let newItem = await this.updateEstimateLineItem(item)
    newAllItems = misc.replaceObject(allItems, newItem)
    let newAfter = await this.updateEstimateLineItem(itemAfter)
    newAllItems = misc.replaceObject(allItems, newAfter)
    if (doubleAfter) {
      let newDoubleAfter = await this.updateEstimateLineItem(doubleAfter)
      newAllItems = misc.replaceObject(allItems, newDoubleAfter)
    }
    return newAllItems
  },
  async sortItemUp (item, allItems) {
    /*
    Moves a singe line item UP in the order of line items.
    Takes care of PATCHing all the related linked list pointers for the related
    estimate line items
    */
    // itemAfter is the one AFTER the passed in `item` -- it may not exist (then `item` is the last item in the list)
    let itemAfter = _.find(allItems, function (i) { return i.comes_after === item.id })
    // itemBefore is the one BEFORE the pass in `item`
    let itemBefore = _.find(allItems, function (i) { return i.id === item.comes_after })
    let newAllItems = null

    item.comes_after = itemBefore.comes_after
    itemBefore.comes_after = item.id
    // This may be at the end of the list, so there may not be an itemAfter
    if (itemAfter) {
      itemAfter.comes_after = itemBefore.id
    }

    let newBefore = await this.updateEstimateLineItem(itemBefore)
    newAllItems = misc.replaceObject(allItems, newBefore)
    let newItem = await this.updateEstimateLineItem(item)
    newAllItems = misc.replaceObject(allItems, newItem)

    if (itemAfter) {
      let newAfter = await this.updateEstimateLineItem(itemAfter)
      newAllItems = misc.replaceObject(allItems, newAfter)
    }
    return newAllItems
  },
  async sortOptionDown (item, allItems) {
    /*
    Moves a singe line item DOWN in the order of line items.
    Takes care of PATCHing all the related linked list pointers for the related
    estimate line items
    */
    let itemAfter = _.find(allItems, function (i) { return i.comes_after === item.id })
    let doubleAfter = _.find(allItems, function (i) { return i.comes_after === itemAfter.id })
    let newAllItems = null
    itemAfter.comes_after = item.comes_after
    item.comes_after = itemAfter.id
    if (doubleAfter) {
      doubleAfter.comes_after = item.id
    }

    let newItem = await this.updateOptionalLineItem(item)
    newAllItems = misc.replaceObject(allItems, newItem)
    let newAfter = await this.updateOptionalLineItem(itemAfter)
    newAllItems = misc.replaceObject(allItems, newAfter)
    if (doubleAfter) {
      let newDoubleAfter = await this.updateOptionalLineItem(doubleAfter)
      newAllItems = misc.replaceObject(allItems, newDoubleAfter)
    }
    return newAllItems
  },
  // async deleteLineItem (obj) {
  //   return await axios.delete(endpoints.estimateLineItems + obj.id + '/').then((response) => {
  //     return response.data
  //   })
  // },
  async deleteLineItem (item, allItems) {
    /*
    Removes a single estimate line item from the list, updating the necessary
    pointers for the affected estimate line items
    */
    // itemAfter is the one AFTER the passed in `item` -- it may not exist (then `item` is the last item in the list)
    let itemAfter = _.find(allItems, function (i) { return i.comes_after === item.id })
    // itemBefore is the one BEFORE the pass in `item`
    // let itemBefore = _.find(allItems, function (i) { return i.id === item.comes_after })
    let newAllItems = allItems

    if (itemAfter) {
      if (item.comes_after) {
        itemAfter.comes_after = item.comes_after
      } else {
        itemAfter.comes_after = null
      }
    }

    // Remove the reference from the item being deleted
    item.comes_after = null
    newAllItems = misc.removeObject(newAllItems, item)
    await axios.delete(endpoints.estimateLineItems + item.id + '/')

    if (itemAfter) {
      // We put this down here so that we can remove the item first, and then
      // update the main list
      let newAfter = await this.updateEstimateLineItem(itemAfter)
      newAllItems = misc.replaceObject(newAllItems, newAfter)
    }
    // let newBefore = await this.updateEstimateLineItem(itemBefore)
    // newAllItems = misc.replaceObject(newBefore, allItems)

    return newAllItems
  }
}
